export const SPECIAL_PRICES_ATTACHMENT_MODAL_WIDTH = "900px";
